import { TooltipProps } from "@mui/material";
import { Tooltip as MuiToolip } from '@mui/material';
import React from "react";
import '../../styles/components/tooltip.scss';

export const Tooltip = ({ className, ...props }: TooltipProps) => (
  <MuiToolip 
    {...props} 
    classes={{ popper: className }}
  />
)